export default class ModalRow {

  constructor(modal, row) {
    this.modal = modal;
    this.row = row;
    this.count = 1;

    this.rowTotal();
    this.events();
  }

  events() {
    let select = this.row.querySelector('select');
    select.addEventListener('change', () => {
      this.count = select[select.selectedIndex].dataset.count;
      this.updateInOut();
      this.rowTotal();
    });

    let radios = this.row.querySelectorAll('input[type="radio"]');
    radios.forEach( (radio) => {
      radio.addEventListener('change', () => {
        this.updateInOut();
        this.rowTotal();
      });
    } );
  }

  updateInOut() {
    let inOut = this.row.querySelectorAll('input[type="radio"]')[0];
    //console.log(this.count);

    let firstValue = inOut.dataset.firstValue;
    let additionnalValue = inOut.dataset.additionnalValue;

    //console.log(Number(firstValue) + ((this.count-1) * Number(additionnalValue)));

    //inOut.value = Math.round(Number(firstValue) + ((this.count-1) * Number(additionnalValue)));
    //Remove rounding

    inOut.value = Number(firstValue) + ((this.count-1) * Number(additionnalValue));
  }

  rowTotal() {
    let total = 0;
    let total_l = 0;
    let inputs = this.row.querySelectorAll('input');
    let selects = this.row.querySelectorAll('select');

    inputs.forEach( (input) => {
      // Check if input value is a number
      if(!isNaN(input.value)) {

        // If input type is radio or checkbox, only take checked input
        if(input.type === 'radio' || input.type === 'checkbox') {
          if(!input.checked) {
            return;
          }
        }
        total = Number(total) + Number(input.value);
      }
    });

    // Get all form selects
    selects.forEach( (select) => {
      if(!isNaN(select.value)) {
        total = Number(total) + Number(select.value);
      }
    });

    this.row.dataset.total = total;

    /*Total Capacity*/
    let data = (JSON.parse(this.modal.dataset.data));

    // Get all form selects
    selects.forEach( (select) => {
      if(!isNaN(select.value)) {
        total = Number(total) + Number(select.value);
      }

      total_l = data.capacity * Number(select.options[select.selectedIndex].dataset.count);
    });

    this.row.dataset.total_l = total_l;
    this.customEvent();
  }

  customEvent() {
    let event = new Event('modalRowUpdate');
    document.dispatchEvent(event);
  }

  addRow() {
    let parent = this.row.parentNode;
    let newRow = this.row.cloneNode(true);
    let rowCount = this.modal.querySelectorAll('.panel').length;
    newRow.querySelector('.row-number').innerHTML = rowCount + 1;
    newRow.dataset.row = rowCount + 1;

    updateInputsAttribute(newRow.querySelectorAll('label'), 'for', rowCount);
    updateInputsAttribute(newRow.querySelectorAll('select'), 'id', rowCount);
    updateInputsAttribute(newRow.querySelectorAll('input[type="radio"]'), ['id','name'], rowCount);

    parent.appendChild(newRow);

    return newRow;
  }

  removeRow() {
    this.row.remove();
  }

}

function updateInputsAttribute(elements, attributes, counter) {

  if(Array.isArray(attributes)) {

    attributes.forEach( (attribute) => {

      elements.forEach( (element) => {
        let currentAttr = element.getAttribute(attribute);
        element.setAttribute(attribute, `${currentAttr}-${counter + 1}`);
      } );

    } );

  } else {

    elements.forEach( (element) => {
      let currentAttr = element.getAttribute(attributes);
      element.setAttribute(attributes, `${currentAttr}-${counter + 1}`);
    } );

  }
}
